import { render, staticRenderFns } from "./WaitingListCellRendererArrived.vue?vue&type=template&id=bd687dd6&"
import script from "./WaitingListCellRendererArrived.vue?vue&type=script&lang=js&"
export * from "./WaitingListCellRendererArrived.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports